module.exports = __webpack_public_path__ + "img/climate_kic.62d82854.png";